/*eslint-disable*/
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { List, ListItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-kit-react/components/footerStyle.js";
import logo from '../../assets/img/f-logo.png';
const useStyles = makeStyles(styles);

export default function Footer(props) {
  const classes = useStyles();
  const { whiteFont } = props;
  const footerClasses = classNames({
    [classes.footer]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  const aClasses = classNames({
    [classes.a]: true,
    [classes.footerWhiteFont]: whiteFont
  });
  return (
    <footer className={footerClasses}>
     <div className="container">
        <div className="row">
          <div className="col-md-4">
            <div className="footer-logo">
              <a href="index.html"><img src={logo}  alt="" /></a>
            </div>
          </div>
          <div className="col-md-8">
            <div className="footer-menu">
              <ul>
                <li><a href="#">Get in touch</a></li>
                <li><a href="#"><i className="far fa-envelope" /></a></li>
                <li><a href="mailto:info@beeplink.com">info@beeplink.com</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      {/* <div className={classes.container}>
        <div className={classes.left}>
          <List className={classes.list}>
            <ListItem className={classes.inlineBlock}>
              <a
                href="/"
                className={classes.block}
              >
                Home
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a
                href="/booking-history"
                className={classes.block}
              >
                My Account
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a
                href="/about-us"
                className={classes.block}
              >
                About Us
              </a>
            </ListItem>
            <ListItem className={classes.inlineBlock}>
              <a
                href="/privacy-policy"
                className={classes.block}
              >
                Privacy Policy
              </a>
            </ListItem>
          </List>
        </div>
        <div className={classes.right}>
          &copy; {1900 + new Date().getYear() + " "} 
          <a
            href="https://exicube.com"
            className={aClasses}
            target="_blank"
          >
            Exicube
          </a>
        </div>
      </div> */}
    </footer>
  );
}

Footer.propTypes = {
  whiteFont: PropTypes.bool
};
